import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { DeskPool } from '../../DeskPool';
import { selectMatchState } from '../../../../store/match';
import { useAppSelector } from '../../../../hooks';
import { BachelorTarget } from "../../../molecules/BachelorTarget/BachelorTarget";
export function BachelorSelecting() {
    var _a;
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const matchState = useAppSelector(selectMatchState);
    const currentPlayer = (_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer;
    const gameButtonState = useMemo(() => ({
        text: ``,
        visible: false,
        onClick: () => {
        }
    }), [selectedPlayer]);
    const getAddOnComponent = ({ player, onClose }) => (_jsx(BachelorTarget, { votingPlayer: currentPlayer, player: player, onClose: onClose }));
    return _jsx(DeskPool, { onPlayerClickAction: null, gameButtonState: gameButtonState, addOnComponent: getAddOnComponent });
}
